import "../../../app/globals";
import React, { useMemo, useEffect } from "react";
import "./index.scss";
import MdaePopup, {
  MdaePopupTitle,
  MdaePopupContent,
  MdaePopupFooter,
  MdaePopupFooterEndButtons,
  MdaePopupFooterStartButtons,
} from "../../../common_components/common_widgets/popup";
import MdaeTabPanel from "../../../common_components/common_widgets/tab-panel";
import { callOperation } from "async-ops";
import {
  SET_CASE_DETAIL_DATA,
  SET_DOCUMENT_COUNT_PROPERTY,
  SET_EA_CASE_DETAIL_TAB_VISIBLE,
  SET_IS_CASE_DOCUMENT_COUNT_SEEN,
  SHOW_ALTERNATE_MRN,
  SHOW_ORIGINAL_ACCOUNT_NO,
  TOGGLE_ACCOUNT_TO_ORIGINAL_ACCOUNT_NO,
  TOGGLE_CASE_DETAIL_POPUP,
  TOGGLE_CASE_DETAIL_WARNING_POPUP,
  TOGGLE_MRN_TO_ALTERNATE_MRN,
  SET_CASE_DATA_SAVED,
} from "./reducers/case-detail-reducer";
import { useDispatch, useSelector } from "react-redux";
import { first, isEqual, isNil, last } from "lodash";
import { formatUSLocaleDate } from "../../../utils/dateUtils";
import { Item } from "devextreme-react/tab-panel";
import MdaeButton from "../../../common_components/common_widgets/button";
import {
  FG_AUDIT_A_CASE,
  FG_EXTERNAL_USER_TASK_EDITING,
  hasAnyFeatureGroupAccess,
} from "../../../common_components/user-permissions-helper";
import "bootstrap/dist/css/bootstrap.min.css";
import { bindActionCreators } from "redux";
import CaseData from "./case-data";
import { actions as asyncActions } from "async-ops";
import { GET_CASE_CLAIM_DETAILS } from "../../../common_components/case-details/services/get-case-claim-details";
import { SAVE_CASE_DETAIL_DATA } from "./services/save-case-detail-data";
import { UPDATE_CASE_DETAIL_LIST_DATA } from "../case-list/reducers/case-list-reducer";
import {
  SET_AUDIT_ROUND_DATA,
  SET_REFRESH_AUDIT_SUMMARY_DATA,
} from "../reducers/external-audit-reducer";
import {
  HIDE_LOADER,
  SHOW_LOADER,
} from "../../../common_components/mdae-common-reducer";
import { SET_IS_STOP_DOCUMENT_POLLING } from "../../../common_components/document-management/reducers/document-management-reducer";
import {
  caseDataValidationGroup,
  getCaseDataTabDataById,
  toggleCaseDataValidationMode,
} from "./case-data/component";
import {
  TaskTabPanel,
  DocumentManagementTabPanel,
  ExtraFieldsTabPanel,
  CaseFieldsTabPanel,
  EsmdTabPanel,
} from "./ea-case-view-tab-components";
import {
  caseDataValidationModes,
  defaultCaseData,
  formatCaseDataObject,
  SET_CASE_DATA_ACCORDION_SELECTED_KEYS,
  SET_CASE_FORM_DATA,
} from "./case-data/reducers/case-data-reducer";
import DenialPredictorResponseGridPopup, {
  toggleDenialPredictorResponseGridPopup,
} from "./denial-predictor-response-grid";
import MdaePopover from "../../../common_components/common_widgets/popover";
import { GET_UNSEEN_DOCUMENT_COUNT } from "../../../common_components/document-management/services/get-unseen-document-count";
import { MARK_DOCUMENT_SEEN } from "../../../common_components/document-management/services/mark-document-seen";
import { TOGGLE_DENIAL_PREDICTOR_ALERT_POPOVER } from "../../analyzer/denials-predictor/reducers/denials-predictor-reducer";
import { ATTACHED_LEVEL_NAME } from "../constants";
import { checkListIsEqual } from "../../../common_components/mdae-framework";
import { GET_ESMD_SUBMISSSIONS } from "../../../common_components/case-details/esMd-dashboard/services/get-esmd-submission";
import { SET_ESMD_SELECTED_TAB_INDEX } from "../../../common_components/case-details/esMd-dashboard/reducers/esmd-submission-reducer";
import { DISABLE_ANIMATION_CONFIG } from "../../../common_components/common_widgets/popup/component";
import { toggleCaseDetailPopup, validateAndSaveCaseData } from "./case-detail-common-functions";
import {
  loadGridState,
  saveGridSetting,
} from "../../../common_components/common_widgets/data-grid/component";
import {
  LabelWithCopyText,
  ToggleLabelWithCopyText,
} from "../../../common_components/common-task-case-header/component";
import { saveManualCase } from "../../../common_components/add-case-manual/component";
import { saveManualCaseFromValidation } from "../../../common_components/add-case-manual/show-validation-summary-popup";
import { openUserTaskInEditMode, TASK_DISPLAY_MODES, TaskDisplayMode, validateAndsaveUserTask } from "../../../common_components/user-task-list/add-user-task";
import { toggleUserTaskPopup } from "../../../common_components/user-task-list/component";
import dxDataGrid from "devextreme/ui/data_grid";


export const toggleCaseDetailWarningPopup = (dispatch, isVisible) => {
  dispatch({
    type: TOGGLE_CASE_DETAIL_WARNING_POPUP,
    data: {
      isCaseDetailWarningPopupVisible: isVisible,
    },
  });
};
export const saveCaseDataTab = (
  dispatch,
  caseDataTabData,
  currentUser,
  isSaveAndCloseButton = false,
  isSaveAndNew = false
): Promise<any> => {
  dispatch({ type: SHOW_LOADER });
  const formatCaseData = formatCaseDataObject(caseDataTabData);
  return callOperation(SAVE_CASE_DETAIL_DATA, formatCaseData).then(
    (response) => {
      dispatch({ type: HIDE_LOADER });
      dispatch({
        type: UPDATE_CASE_DETAIL_LIST_DATA,
        data: {
          eaCaseId: caseDataTabData?.eaCaseId,
          payerCaseId: caseDataTabData?.payerCaseId,
          caseStatusCd: caseDataTabData?.statusName,
          caseFinalOutcome: caseDataTabData?.caseFinalOutcomeName,
          currentRoundOutcome: caseDataTabData?.currentRoundOutcomeName,
          updatedBy: currentUser?.lastName + ", " + currentUser?.firstName,
          updateDate: new Date(),
          //todo current round here
        },
      });
      dispatch({
        type: SET_REFRESH_AUDIT_SUMMARY_DATA,
        data: true,
      });
      dispatch({
        type: SET_CASE_DATA_SAVED,
        data: { isCaseDataSaved: true },
      });
      if (response?.eaAuditRounds?.length > 0)
        dispatch({
          type: SET_AUDIT_ROUND_DATA,
          data: {
            eaAuditRounds: response.eaAuditRounds,
          },
        });
      if (isSaveAndCloseButton)
        toggleCaseDetailPopup(dispatch, false);
      else if (!isSaveAndNew)
        getCaseDataTabDataById(dispatch, caseDataTabData?.eaCaseId, true);
    }
  );
};

export const CASE_DETAIL_POPUP_MODES = {
  VIEW: "VIEW",
  VIEW_WITH_TASK: "VIEW_WITH_TASK",
  CREATE: "CREATE",
}
interface ICaseDetailProps {
  auditGroupId?: number;
  caseMyTaskWidgetId: string;
  caseMyPastDueTaskDrawerId: string;
  caseMyThisWeekTaskDrawerId: string;
  caseMyUpcomingTaskDrawerId: string;
  caseMyCompletedTaskDrawerId: string;
  eaRoundId: number;
  isViewOnly?: boolean;
  isHideBillingHistoryLink?: boolean;
  isFromDenialPredictor?: boolean;
  isSaveAndNextBtnVisible?: boolean;
  doNotLoadDatasourcesInd?:boolean;
  refreshCasesList?: () => void;
  documentId?: number;
}
const CaseDetail: React.FC<ICaseDetailProps> = (props) => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const completeCaseDetail = useSelector(
    (state) => state["caseDetailReducer"].completeCaseDetail,
    isEqual
  );
  const caseDetailData = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData,
    isEqual
  );
  const caseDataTabData = useSelector(
    (state) => state["caseDataReducer"].caseData,
    isEqual
  );
  const currentUser = useSelector(
    (state) => state["mdaeNavigationBarReducer"].currentUser,
    isEqual
  );

  const isSaveAndCloseButtonClickable = useSelector(
    (state: any) => state["caseDetailReducer"].isSaveAndCloseButtonClickable,
    isEqual
  );

  const isDocumentManagementEnabled = useSelector(
    (state) => state["documentManagementReducer"].isDocumentManagementEnabled,
    isEqual
  );

  const hasAuditACaseAccess = useMemo(
    () => hasAnyFeatureGroupAccess([FG_AUDIT_A_CASE], currentUser),
    [currentUser]
  );
  const isExternalAuditReadOnly = useSelector(
    (state) => state["auditPropertiesReducer"].isExternalAuditReadOnly,
    isEqual
  );
  const caseDetailPopupTitle = useSelector(
    (state: any) => state["caseDetailReducer"].caseDetailPopupTitle,
    isEqual
  );
  const isDocumentCountVisibleForDocumentManagementTab = useSelector(
    (state) =>
      state["caseDetailReducer"].isDocumentCountVisibleForDocumentManagementTab,
    isEqual
  );
  const documentUploadedFromDifferentUser = useSelector(
    (state) => state["caseDetailReducer"].documentUploadedFromDifferentUser,
    isEqual
  );
  const isDocumentTabVisible = useSelector(
    (state) => state["caseDetailReducer"].isDocumentTabVisible,
    isEqual
  );
  const hasEditAccess = hasAuditACaseAccess && !isExternalAuditReadOnly;

  const isDenialResponsePopupVisible = useSelector(
    (state: any) =>
      state["denialsPredictorReducer"].isDenialResponsePopupVisible,
    isEqual
  );
  const caseDetailsDenialResponseList = useSelector(
    (state: any) => state.denialsPredictorReducer.caseDetailsDenialResponseList,
    checkListIsEqual
  );

  const esmdSubmissionList = useSelector(
    (state) => state["caseDetailReducer"].esmdSubmissionList,
    isEqual
  );
  const isCurrentRequesterReviewContractorValid = useSelector(
    (state) =>
      state["externalAuditReducer"].isCurrentRequesterReviewContractorValid,
    isEqual
  );
  const isCurrentContentTypeInvalidForReviewContractor = useSelector(
    (state) =>
      state["externalAuditReducer"]
        .isCurrentContentTypeInvalidForReviewContractor,
    isEqual
  );
  const isTabChangedProgrammatically = useSelector(
    (state) => state["esmdSubmissionReducer"].isTabChangedProgrammatically,
    isEqual
  );
  const shouldShowCaseDataTab = useSelector(
    (state) =>
      state["caseDetailReducer"].caseDetailData.eaCaseId > 0 ||
      state["caseDetailReducer"].caseDetailData.mode ===
        CASE_DETAIL_POPUP_MODES.CREATE
  );
  const caseDetailPopupMode = useSelector(
    (state) =>
      state["caseDetailReducer"].caseDetailData.mode
  );

  const shouldShowTaskAndDocumentsTab = useSelector(
    (state) =>
      state["caseDetailReducer"].caseDetailData.eaCaseId > 0
  );
  const showOriginalAcct = useSelector(
    (state) => state["caseDetailReducer"].showOriginalAcct,
    isEqual
  );
  const showAlternateMRN = useSelector(
    (state) => state["caseDetailReducer"].showAlternateMRN,
    isEqual
  );
  const addCaseManualPopupMode = useSelector(
    (state) => state["addCaseManualReducer"].addCaseManualPopupMode
  );
  const addCaseManualFormData = useSelector(
    (state) => state["addCaseManualReducer"].addCaseManualFormData
  );
  const auditPropertiesData = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData
  );
  const caseSearchPageData = useSelector(
    (state) => state["caseSearchPageReducer"]
  );
  const firstEaRound = useSelector((state) =>
    last(state["externalAuditReducer"].eaAuditRounds),
    isEqual
  );
  const addCaseToRoundNumber = useSelector(
    (state) => state["externalAuditReducer"].addCaseToRoundNumber
  );
  const roundStartDate = useSelector(
    (state) => state["externalAuditReducer"].roundStartDate
  );
  const saveManualCaseDataParams = useSelector(
    (state) => state["addCaseManualReducer"].saveManualCaseDataParams
  );
  const isManualExpediteCaseSearch = useSelector(
    (state) => state["addCaseManualReducer"].isManualExpediteCaseSearch
  );
  const isSaveFromValidationForManualExpediteCaseSearch = useSelector(
    (state) =>
      state["addCaseManualReducer"]
        .isSaveFromValidationForManualExpediteCaseSearch
  );
  const isExternalUser = useMemo(
    () => hasAnyFeatureGroupAccess([FG_EXTERNAL_USER_TASK_EDITING], currentUser),
    [currentUser]
  );
  const eaAuditRounds = useSelector(
    (state) => state["externalAuditReducer"].eaAuditRounds,
    isEqual
  );
  const userTaskFormData = useSelector(
    (state: any) => state["userTaskListReducer"].userTaskFormData,
    isEqual
  );
  // Prefer caseDataTabData.roundData (updated on local round deletion) over eaAuditRounds (stale until save response).
  const currentEaRoundId = (first(caseDataTabData?.roundData) as any)?.eaRoundId ?? (eaAuditRounds && eaAuditRounds[0]?.eaRoundId);
 const dosText = completeCaseDetail?.statementFromDate
      ? `${formatUSLocaleDate(
        completeCaseDetail.statementFromDate
        )} - ${formatUSLocaleDate(completeCaseDetail.statementToDate)}`
      : "";
  const ToggleAccountNoStorageKey = { storageKey: SHOW_ORIGINAL_ACCOUNT_NO };
  const ToggleAlternateMRNStorageKey = { storageKey: SHOW_ALTERNATE_MRN };

  useEffect(() => {
    loadGridState(dispatch, ToggleAccountNoStorageKey).then((response) => {
      dispatch({
        type: TOGGLE_ACCOUNT_TO_ORIGINAL_ACCOUNT_NO,
        data: {
          showOriginalAcct: JSON.parse(response),
        },
      });
    });
  }, []);

  useEffect(() => {
    loadGridState(dispatch, ToggleAlternateMRNStorageKey).then((response) => {
      dispatch({
        type: TOGGLE_MRN_TO_ALTERNATE_MRN,
        data: {
          showAlternateMRN: JSON.parse(response),
        },
      });
    });
  }, []);

  useEffect(() => {
    if (Object.keys(caseDetailData).length > 0) {
      asyncAction.asyncOperationStart(
        GET_CASE_CLAIM_DETAILS,
        isManualCase(caseDetailData)
          ? {
              eaCaseId: caseDetailData?.eaCaseId,
              isManualCase: true,
            }
          : {
              caseDetailId: caseDetailData.caseDetailId,
              type: "View",
            }
      );
    }
    if (caseDetailData?.eaCaseId) {
      callOperation(GET_UNSEEN_DOCUMENT_COUNT, {
        attachedLevelId: caseDetailData?.eaCaseId,
        attachedLevelName: ATTACHED_LEVEL_NAME.ExternalAuditCase,
      }).then((response) => {
        dispatch({
          type: SET_DOCUMENT_COUNT_PROPERTY,
          data: {
            isDocumentCountVisibleForDocumentManagementTab:
              response.data == 0 ? false : true,
            documentUploadedFromDifferentUser: response.data,
          },
        });
      });
      asyncAction.asyncOperationStart(GET_ESMD_SUBMISSSIONS, {
        eaCaseId: caseDetailData?.eaCaseId,
      });
    }
  }, [caseDetailData.caseDetailId, caseDetailData?.eaCaseId]);

  useEffect(() => {
    return () => {
      dispatch({
        type: SET_EA_CASE_DETAIL_TAB_VISIBLE,
        data: {
          isTaskTabVisible: false,
          isDocumentTabVisible: false,
          isCaseFieldTabVisible: false,
          isExtraFieldTabVisible: false,
          isEsmdDashboardTabVisible: false,
        },
      });
      dispatch({
        type: SET_CASE_FORM_DATA,
        data: {
          caseData: { ...defaultCaseData },
        },
      });
      dispatch({
        type: SET_CASE_DATA_ACCORDION_SELECTED_KEYS,
        data: {
          keys: [],
        },
      });
      dispatch({
        type: SET_CASE_DETAIL_DATA,
        data: {
          caseDetailData: {},
          eaCaseDetailsTabPanelSelectedIndex: 0,
        },
      });
      dispatch({
        type: SET_IS_STOP_DOCUMENT_POLLING,
        isStopDocumentPooling: true,
      });
    };
  }, []);

  const getCaseDetailWarningPopupTitle = () => {
    return (
      <MdaePopupTitle
        isSmallPopup
        closePopupHandler={() => {
          toggleCaseDetailWarningPopup(dispatch, false);
        }}
      >
        Warning
      </MdaePopupTitle>
    );
  };
  const onDenialAlertClick = () => {
    setTimeout(() => {
      toggleDenialPredictorResponseGridPopup(dispatch, true);
    });
  };
  const getCaseDetailPopupTitle = () => {
    return (
      <MdaePopupTitle
        className={"ea-case-details-container"}
        closePopupHandler={() => {
          toggleCaseDetailPopup(dispatch, false);
        }}
        customTitleRender={() => {
          return (
            <div className="case-detail-popup-header vertical-split">
              <LabelWithCopyText
                label="Pt. Name:"
                value={`${completeCaseDetail.patientLastName}, ${completeCaseDetail.patientFirstName}`}
                title={`${completeCaseDetail.patientLastName}, ${completeCaseDetail.patientFirstName}`}
              />
              <LabelWithCopyText
                label="DOB:"
                title={
                  completeCaseDetail?.dob
                    ? formatUSLocaleDate(completeCaseDetail.dob)
                    : ""
                }
                value={
                  completeCaseDetail?.dob
                    ? formatUSLocaleDate(completeCaseDetail.dob)
                    : ""
                }
              />
              <ToggleLabelWithCopyText
                labelOn="Alt MRN:"
                labelOff="MRN:"
                title={
                  showAlternateMRN
                    ? completeCaseDetail?.patientAlternateMRN
                    : completeCaseDetail?.patientMRN
                }
                value={
                  showAlternateMRN
                    ? completeCaseDetail?.patientAlternateMRN
                    : completeCaseDetail?.patientMRN
                }
                toggleValue={showAlternateMRN}
                onToggleChange={(e) => {
                  if (e.event) {
                    saveGridSetting(
                      e.value,
                      ToggleAlternateMRNStorageKey,
                      true
                    );
                    dispatch({
                      type: TOGGLE_MRN_TO_ALTERNATE_MRN,
                      data: { showAlternateMRN: e.value },
                    });
                  }
                }}
              />
              <ToggleLabelWithCopyText
                labelOn="Original Acct#:"
                labelOff="Acct#:"
                title={
                  showOriginalAcct
                    ? completeCaseDetail?.patientAcctNoOrig
                    : completeCaseDetail?.patientAcctNo
                }
                value={
                  showOriginalAcct
                    ? completeCaseDetail?.patientAcctNoOrig
                    : completeCaseDetail?.patientAcctNo
                }
                toggleValue={showOriginalAcct}
                onToggleChange={(e) => {
                  if (e.event) {
                    saveGridSetting(e.value, ToggleAccountNoStorageKey, true);
                    dispatch({
                      type: TOGGLE_ACCOUNT_TO_ORIGINAL_ACCOUNT_NO,
                      data: { showOriginalAcct: e.value },
                    });
                  }
                }}
              />
                <LabelWithCopyText
                label="DOS:"
                value={dosText}
                  title={dosText}
              />
            </div>
          );
        }}
      >
        {props.isFromDenialPredictor &&
        caseDetailsDenialResponseList?.length > 0 ? (
          <div
            className="case-details-denial-alert-title"
            onClick={onDenialAlertClick}
          >
            <div>{caseDetailPopupTitle}</div>
            <div className="denial-predictor-alert">
              <i className="fa fa-warning warning-icon denial-alert-icon"></i>
              <div
                className="mdae-data-field-label denial-alert-text"
                onMouseEnter={() => {
                  dispatch({
                    type: TOGGLE_DENIAL_PREDICTOR_ALERT_POPOVER,
                    data: {
                      isAlertPopoverVisible: true,
                    },
                  });
                }}
                onMouseLeave={() => {
                  dispatch({
                    type: TOGGLE_DENIAL_PREDICTOR_ALERT_POPOVER,
                    data: {
                      isAlertPopoverVisible: false,
                    },
                  });
                }}
              >
                Alert: Denial Risk
                {caseDetailsDenialResponseList?.length > 0 ? (
                  <MdaePopover
                    target={".denial-predictor-alert"}
                    position={"top"}
                    mdaeDataUpdaterConfig={[
                      {
                        actionType: TOGGLE_DENIAL_PREDICTOR_ALERT_POPOVER,
                        reducerName: "denialsPredictorReducer",
                        widgetOptionBindings: {
                          visible: "isAlertPopoverVisible",
                        },
                      },
                    ]}
                  >
                    <div>
                      {caseDetailsDenialResponseList.length > 1 && (
                        <div>
                          Denials Predictor has flagged this line for multiple
                          rules.
                          <div>
                            Click on this icon to see all flags on the case
                          </div>
                        </div>
                      )}
                      {caseDetailsDenialResponseList.length == 1 && (
                        <>
                          <div>
                            Denials Predictor has flagged this claim as a
                            potential denial risk:
                          </div>
                          <div className={"denial-popover-info"}>Line</div>
                          {caseDetailsDenialResponseList[0].cptDrg}
                          {caseDetailsDenialResponseList[0].claimTypeCode.toUpperCase() ==
                            "I" && (
                            <div>
                              <div className={"denial-popover-info"}>
                                Revenue Code
                              </div>
                              {caseDetailsDenialResponseList[0].revenueCode}
                            </div>
                          )}
                          <div className={"denial-popover-info"}>Rule</div>
                          {caseDetailsDenialResponseList[0].ruleDetail}
                          <div className={"denial-popover-info"}>
                            Explanation
                          </div>
                          {caseDetailsDenialResponseList[0].ruleExplanation}
                          <div className={"denial-popover-info"}>
                            Recommendation
                          </div>
                          {
                            caseDetailsDenialResponseList[0]
                              .actionRecommendation
                          }
                          <div className={"denial-popver-text"}>
                            Click on this warning to see more details
                          </div>
                        </>
                      )}
                    </div>
                  </MdaePopover>
                ) : null}
              </div>
            </div>
          </div>
        ) : (
          <div>{caseDetailPopupTitle}</div>
        )}
      </MdaePopupTitle>
    );
  };
    const onUserTaskEditClick = (selectedRowData, userTaskSelectedIndex, displayMode: TaskDisplayMode = TASK_DISPLAY_MODES.TASK_POPUP) => {
      return openUserTaskInEditMode(
        selectedRowData,
        toggleUserTaskPopup,
        userTaskSelectedIndex,
        dispatch,
        true,
        false,
        displayMode
      );
    };

  return (
    <div>
      <div>
        <MdaePopup
          animation={DISABLE_ANIMATION_CONFIG}
          deferRendering={false}
          minHeight={"100%"}
          width={"100%"}
          wrapperAttr={{ class: "case-detail-popup" }}
          mdaeTitleRender={getCaseDetailPopupTitle}
          mdaeDataUpdaterConfig={[
            {
              actionType: TOGGLE_CASE_DETAIL_POPUP,
              reducerName: "caseDetailReducer",
              widgetOptionBindings: {
                visible: "isCaseDetailPopupVisible",
                //mdaePopupTitle: "caseDetailPopupTitle",
              },
            },
          ]}
          mdaeContentRender={() => (
            <MdaePopupContent className="case-detail-popup-content">
              <MdaeTabPanel
                id="caseDetailTabPanel"
                deferRendering={false}
                onSelectionChanged={(e) => {
                  let data = {
                    isTaskTabVisible: false,
                    isDocumentTabVisible: false,
                    isCaseFieldTabVisible: false,
                    isExtraFieldTabVisible: false,
                    isEsmdDashboardTabVisible: false,
                  };
                  if (isTabChangedProgrammatically) {
                    dispatch({
                      type: SET_ESMD_SELECTED_TAB_INDEX,
                      data: {
                        isTabChangedProgrammatically: false,
                      },
                    });
                  } else {
                    if (esmdSubmissionList?.length > 0) {
                      dispatch({
                        type: SET_ESMD_SELECTED_TAB_INDEX,
                        data: {
                          esmdSelectedTabIndex: 1,
                        },
                      });
                    } else {
                      dispatch({
                        type: SET_ESMD_SELECTED_TAB_INDEX,
                        data: {
                          esmdSelectedTabIndex: 0,
                        },
                      });
                    }
                  }

                  switch (e.component.option("selectedIndex")) {
                    case 0:
                      // Case Data Tab
                      if(userTaskFormData?.userTaskId)
                        break;
                      let taskGridReference = document.getElementById(
                        "userTasksListMyTaskPage",
                      );
                      if (taskGridReference == null) {
                        taskGridReference = document.getElementById(
                          "userTasksListTaskHQPage",
                        );
                      }

                      if (taskGridReference != null) {
                        const userTaskListDataGridInstance = dxDataGrid.getInstance(
                          taskGridReference,
                        ) as dxDataGrid;
                        const selectedRowData = first(
                          userTaskListDataGridInstance?.getSelectedRowsData(),
                        );
                        if (selectedRowData) {
                          onUserTaskEditClick(
                            selectedRowData,
                            0,
                            TASK_DISPLAY_MODES.CASE_POPUP,
                          );
                        }
                      }
                      break;
                    case 1:
                      dispatch({
                        type: SET_EA_CASE_DETAIL_TAB_VISIBLE,
                        data: {
                          isTaskTabVisible: true,
                        },
                      });
                      delete data.isTaskTabVisible;
                      break;
                    case 2:
                      dispatch({
                        type: SET_EA_CASE_DETAIL_TAB_VISIBLE,
                        data: {
                          isDocumentTabVisible: true,
                        },
                      });
                      if (isDocumentCountVisibleForDocumentManagementTab) {
                        callOperation(MARK_DOCUMENT_SEEN, {
                          attachedLevelId: caseDataTabData?.eaCaseId,
                          attachedLevelName:
                            ATTACHED_LEVEL_NAME.ExternalAuditCase,
                        }).then(() => {
                          dispatch({
                            type: SET_IS_CASE_DOCUMENT_COUNT_SEEN,
                            data: {
                              isCaseDocumentCountSeen: true,
                            },
                          });
                        });
                      }
                      delete data.isDocumentTabVisible;
                      break;
                    case 3:
                      dispatch({
                        type: SET_EA_CASE_DETAIL_TAB_VISIBLE,
                        data: {
                          isCaseFieldTabVisible: true,
                        },
                      });
                      delete data.isCaseFieldTabVisible;
                      break;
                    case 4:
                      dispatch({
                        type: SET_EA_CASE_DETAIL_TAB_VISIBLE,
                        data: {
                          isExtraFieldTabVisible: true,
                        },
                      });
                      delete data.isExtraFieldTabVisible;
                      break;
                    case 5:
                      dispatch({
                        type: SET_EA_CASE_DETAIL_TAB_VISIBLE,
                        data: {
                          isEsmdDashboardTabVisible: true,
                        },
                      });
                      delete data.isEsmdDashboardTabVisible;
                      break;
                  }

                  setTimeout(() => {
                    dispatch({
                      type: SET_EA_CASE_DETAIL_TAB_VISIBLE,
                      data: data,
                    });
                  });
                }}
                mdaeDataUpdaterConfig={[
                  {
                    actionType: SET_CASE_DETAIL_DATA,
                    reducerName: "caseDetailReducer",
                    widgetOptionBindings: {
                      selectedIndex: "eaCaseDetailsTabPanelSelectedIndex",
                    },
                  },
                ]}
                itemTitleRender={(e) => {
                  return (
                    <div style={{ display: "flex" }}>
                      <div>
                        {e.title}
                        {e.title == "Document Management" &&
                          isDocumentCountVisibleForDocumentManagementTab &&
                          !isDocumentTabVisible && (
                            <span className="fa-stack">
                              <i className="fa fa-circle fa-stack-2x document-count-bubble"></i>
                              <strong className="fa-stack-1x document-count-text">
                                {documentUploadedFromDifferentUser}
                              </strong>
                            </span>
                          )}
                      </div>
                    </div>
                  );
                }}
              >
                <Item title="Case Data" visible={shouldShowCaseDataTab}>
                  {shouldShowCaseDataTab && (
                    <CaseData
                      eaCaseId={caseDetailData?.eaCaseId}
                      mdAuditCaseId={completeCaseDetail?.caseId}
                    />
                  )}
                </Item>
                <Item title="Tasks" visible={shouldShowTaskAndDocumentsTab}>
                  {shouldShowTaskAndDocumentsTab && (
                    <TaskTabPanel
                      auditGroupId={props.auditGroupId}
                      caseMyTaskWidgetId={props.caseMyTaskWidgetId}
                      caseMyPastDueTaskDrawerId={
                        props.caseMyPastDueTaskDrawerId
                      }
                      caseMyThisWeekTaskDrawerId={
                        props.caseMyThisWeekTaskDrawerId
                      }
                      caseMyUpcomingTaskDrawerId={
                        props.caseMyUpcomingTaskDrawerId
                      }
                      caseMyCompletedTaskDrawerId={
                        props.caseMyCompletedTaskDrawerId
                      }
                      doNotLoadDatasourcesInd ={isNil(props.doNotLoadDatasourcesInd) ? true :props.doNotLoadDatasourcesInd}
                    ></TaskTabPanel>
                  )}
                </Item>
                <Item
                  visible={isDocumentManagementEnabled && shouldShowTaskAndDocumentsTab}
                  title="Document Management"
                >
                  {shouldShowTaskAndDocumentsTab && (
                    <DocumentManagementTabPanel></DocumentManagementTabPanel>
                  )}
                </Item>
                <Item title="Case Fields" visible={
                            !isManualExpediteCaseSearch
                          }>
                  <CaseFieldsTabPanel
                    isHideBillingHistoryLink={props.isHideBillingHistoryLink}
                    isDenialFlagAvailable={
                      props.isFromDenialPredictor &&
                      caseDetailsDenialResponseList?.length > 0
                        ? true
                        : false
                    }
                    isCheckBoxVisibleForCharges={
                      caseDetailData?.eaCaseId && caseDetailData.eaCaseId > 0 ? true : false
                    }
                  ></CaseFieldsTabPanel>
                </Item>
                <Item title="Extra Fields" visible={
                           !isManualExpediteCaseSearch
                          }>
                  <ExtraFieldsTabPanel></ExtraFieldsTabPanel>
                </Item>
                <Item
                  title="esMD Dashboard"
                  visible={
                    (shouldShowTaskAndDocumentsTab &&
                      caseDataTabData?.rqstrRecordSubmissionMethod?.toLowerCase() ===
                        "esmd") ||
                    esmdSubmissionList?.length > 0

                  }
                >
                  <EsmdTabPanel />
                </Item>
              </MdaeTabPanel>
            </MdaePopupContent>
          )}
          mdaeFooterRender={() => {
            return (
              <>
                {!props.isViewOnly && (
                  <MdaePopupFooter>
                    <MdaePopupFooterStartButtons>
                      <MdaeButton
                        id={"btnCancelCaseDetailPopup"}
                        role={"secondary"}
                        onClick={() => {
                          toggleCaseDetailPopup(dispatch, false);
                        }}
                      >
                        Cancel
                      </MdaeButton>
                    </MdaePopupFooterStartButtons>
                    {hasEditAccess && shouldShowCaseDataTab && (
                      <MdaePopupFooterEndButtons>
                        <MdaeButton
                          id={"btnSaveCaseDetail"}
                          role={"primary"}
                          validationGroup={caseDataValidationGroup}
                          visible={
                            caseDetailPopupMode !==
                            CASE_DETAIL_POPUP_MODES.CREATE
                          }
                          onClick={(params) => {
                            const promises = [];
                            if (
                              caseDetailPopupMode ===
                              CASE_DETAIL_POPUP_MODES.VIEW_WITH_TASK
                            ) {
                              promises.push(
                                dispatch(
                                  validateAndsaveUserTask(
                                    params,
                                    true,
                                    {
                                      isExternalUser,
                                      eaRoundId: currentEaRoundId,
                                    },
                                    asyncAction,
                                    TASK_DISPLAY_MODES.CASE_POPUP
                                  ),
                                ),
                              );
                            }
                            promises.push(
                              dispatch(
                                validateAndSaveCaseData(
                                  params,
                                  isCurrentRequesterReviewContractorValid,
                                  isCurrentContentTypeInvalidForReviewContractor,
                                  props.refreshCasesList,
                                  false,
                                  false,
                                  caseDataValidationModes.CASE_LEVEL,
                                  props.documentId,
                                ),
                              ),
                            );
                            Promise.all(promises);
                          }}
                        >
                          Save
                        </MdaeButton>
                        <MdaeButton
                          id={"btnSaveAndNextDetail"}
                          role={"primary"}
                          validationGroup={caseDataValidationGroup}
                          visible={Boolean(props.isSaveAndNextBtnVisible)}
                          onClick={(params) => {
                            dispatch(
                              validateAndSaveCaseData(
                                params,
                                isCurrentRequesterReviewContractorValid,
                                isCurrentContentTypeInvalidForReviewContractor,
                                props.refreshCasesList,
                                false,
                                true,
                                caseDataValidationModes.CASE_LEVEL,
                                props.documentId,
                              ),
                            );
                          }}
                        >
                          Save and Next
                        </MdaeButton>
                        <MdaeButton
                          id={"btnSaveAndCloseCaseDetail"}
                          role={"primary"}
                          validationGroup={caseDataValidationGroup}
                          visible={!isManualExpediteCaseSearch}
                          onClick={(params) => {
                            const promises = [];
                            if (
                              caseDetailPopupMode ===
                              CASE_DETAIL_POPUP_MODES.VIEW_WITH_TASK
                            ) {
                              promises.push(
                                dispatch(
                                  validateAndsaveUserTask(
                                    params,
                                    true,
                                    {
                                      isExternalUser,
                                      eaRoundId: currentEaRoundId,
                                    },
                                    asyncAction,
                                    TASK_DISPLAY_MODES.CASE_POPUP
                                  ),
                                ),
                              );
                            }
                            promises.push(
                              dispatch(
                                validateAndSaveCaseData(
                                  params,
                                  isCurrentRequesterReviewContractorValid,
                                  isCurrentContentTypeInvalidForReviewContractor,
                                  props.refreshCasesList,
                                  false,
                                  false,
                                  caseDataValidationModes.CASE_LEVEL,
                                  props.documentId,
                                ),
                              ),
                            );
                            Promise.all(promises).then((results) => {
                              if (results.every(result => result !== false)) {
                                toggleCaseDetailPopup(dispatch, false);
                              }
                            });
                          }}
                        >
                          {caseDetailPopupMode ===
                          CASE_DETAIL_POPUP_MODES.CREATE
                            ? "Save And Create Audit"
                            : "Save and Close"}
                        </MdaeButton>
                        <MdaeButton
                          id={"btnSaveAndCloseCaseDetail"}
                          role={"primary"}
                          validationGroup={caseDataValidationGroup}
                          visible={isManualExpediteCaseSearch === true}
                          onClick={(params) => {
                            toggleCaseDataValidationMode(
                              dispatch,
                              caseDataValidationModes.CASE_LEVEL
                            );
                            let result = null;
                            if (params.validationGroup)
                              result = params.validationGroup.validate();
                            if (result && result.isValid) {
                              if (
                                isCurrentRequesterReviewContractorValid ==
                                  false ||
                                isCurrentContentTypeInvalidForReviewContractor ==
                                  false
                              )
                                return;
                              let caseManualFormData={
                                    ...addCaseManualFormData,
                                    statementFromDateString:(addCaseManualFormData.statementFromDateString?? formatUSLocaleDate(caseSearchPageData?.serviceFrom)),
                                    statementToDateString:(addCaseManualFormData.statementToDateString?? formatUSLocaleDate(caseSearchPageData?.serviceTo))
                                  };
                              if (
                                isSaveFromValidationForManualExpediteCaseSearch ===
                                true
                              ) {
                                saveManualCaseFromValidation(
                                  dispatch,
                                  addCaseManualPopupMode,
                                  caseManualFormData,
                                  auditPropertiesData?.eaAuditId,
                                  firstEaRound?.eaRoundId,
                                  props.refreshCasesList,
                                  auditPropertiesData,
                                  addCaseToRoundNumber,
                                  caseDataTabData
                                );
                              } else {
                                saveManualCase(
                                  dispatch,
                                  addCaseManualPopupMode,
                                  caseManualFormData,
                                  auditPropertiesData,
                                  firstEaRound,
                                  addCaseToRoundNumber,
                                  roundStartDate,
                                  saveManualCaseDataParams.refreshCasesList,
                                  saveManualCaseDataParams.params,
                                  saveManualCaseDataParams.isNewAfterSave,
                                  caseDataTabData
                                );
                              }
                            }
                            else{
                              (first(result?.brokenRules) as any)?.validator?.focus();
                            }
                          }}
                        >
                          {caseDetailPopupMode ===
                          CASE_DETAIL_POPUP_MODES.CREATE
                            ? "Save And Create Audit"
                            : "Save and Close"}
                        </MdaeButton>
                      </MdaePopupFooterEndButtons>
                    )}
                  </MdaePopupFooter>
                )}
              </>
            );
          }}
        />
        <MdaePopup
          deferRendering={false}
          width={500}
          height={210}
          className=""
          mdaeTitleRender={getCaseDetailWarningPopupTitle}
          mdaeDataUpdaterConfig={[
            {
              actionType: TOGGLE_CASE_DETAIL_WARNING_POPUP,
              reducerName: "caseDetailReducer",
              widgetOptionBindings: {
                visible: "isCaseDetailWarningPopupVisible",
              },
            },
          ]}
          mdaeContentRender={() => {
            return (
              <MdaePopupContent>
                <div>
                  The case data indicates that there are still dollars in
                  review. Do you want to add a final outcome without a complete
                  financial impact?
                </div>
              </MdaePopupContent>
            );
          }}
          mdaeFooterRender={() => {
            return (
              <MdaePopupFooter>
                <MdaePopupFooterStartButtons>
                  <MdaeButton
                    id={"pnlCancelSecondaryButton"}
                    role={"secondary"}
                    onClick={() => {
                      toggleCaseDetailWarningPopup(dispatch, false);
                    }}
                  >
                    Cancel
                  </MdaeButton>
                </MdaePopupFooterStartButtons>
                <MdaePopupFooterEndButtons>
                  <MdaeButton
                    id={"pnlOkPrimaryButton"}
                    role={"primary"}
                    onClick={() => {
                      saveCaseDataTab(dispatch, caseDataTabData, currentUser);
                      toggleCaseDetailWarningPopup(dispatch, false);
                      if (isSaveAndCloseButtonClickable)
                        toggleCaseDetailPopup(dispatch, false);
                    }}
                  >
                    OK
                  </MdaeButton>
                </MdaePopupFooterEndButtons>
              </MdaePopupFooter>
            );
          }}
        />
      </div>
      {isDenialResponsePopupVisible && (
        <DenialPredictorResponseGridPopup {...props} />
      )}
    </div>
  );
};
export default CaseDetail;
export const isManualCase = (currentSelectedRowData) => {
  return (
    currentSelectedRowData?.auditCaseEntryTypeCd?.toUpperCase() === "MANUAL"
  );
};
